import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

interface ExitConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDiscard: () => void;
  onSaveAndExit: () => void;
}

export function ExitConfirmDialog({ open, onOpenChange, onDiscard, onSaveAndExit }: ExitConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Exit without finishing?</AlertDialogTitle>
          <AlertDialogDescription>
            You're in the middle of building an A/B test. Save it as a draft so you can pick it back up later, or discard your changes.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep editing</AlertDialogCancel>
          <Button
            variant="outline"
            onClick={() => {
              onOpenChange(false);
              onDiscard();
            }}
          >
            Discard
          </Button>
          <AlertDialogAction
            onClick={() => {
              onOpenChange(false);
              onSaveAndExit();
            }}
          >
            Save & exit
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
